import React from "react";
import "../modal.css";
import {RiCloseLine} from "react-icons/ri";

export default class CyberfaceModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            position: '', 
            nfl2k5team: '',
            cyberfacePics:[],
            loading: true,
        }
    }
    onClose = e => {
        this.setState({cyberfacePics : [],loading: true});
        this.props.onClose && this.props.onClose(e);
    };
    
    handleImageLoad = () => {
        
        console.log("images loaded");
        this.setState({loading: false});
    }


    render() {
       if (!this.props.isOpen) {
         return null;
       }

        let isLoading = this.state.loading
            ? <p><em className="cyberfaceLoad">Loading...</em></p>
            : "";
       
       return <div>
            <div className="darkBG"/>
            <div className="centered">
                <div className="cyberfaceModal">
                    <div className="modalHeader">
                        <h5 className="heading">Original Cyberface</h5>
                    </div>
                    <button className="closeBtn" onClick={this.onClose}>
                        <RiCloseLine style={{marginBottom: "-3px"}}/>
                    </button>
                    <div className="modalContent">
                        <h3 className="cyberfaceHeader">NFL 2k5 Original Player
                            : {this.props.playerData.nfl2k5team + "- " + this.props.playerData.firstName + " " + this.props.playerData.lastName}
                        </h3>
                         
                        {isLoading}
                        <div className="cyberfacePics">
                            {this.props.playerImages.map((item) => (
                                <div className="cyberfaceCard" key={item.hash}>
                                    <img src={item.url} onLoad={this.handleImageLoad} alt="Player cyberface"></img>
                                    <div className="cyberfaceHash">{item.hash}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }


}

